/* ------------------------- External Dependencies -------------------------- */
import React, { Component } from 'react'
import { Absolute } from 'particles'
/* ---------------------------- Module Package ------------------------------ */
export default props => <Absolute is='aside' bs={2} top bottom right left {...props} {...props.layout}/>





// WEBPACK FOOTER //
// ./src/interface/theme/layout/zones/DashboardAside/render/index.js